import { http } from '@/api/http'
import { normalizeZone, unwrapList } from '@/api/normalizers'
import type { Zone } from '@/lib/pos-types'

export const zonesApi = {
  list: async (): Promise<Zone[]> => {
    const res = await http.get<unknown>('/zones')
    return unwrapList(res.data).map(normalizeZone)
  },
  create: async (payload: unknown): Promise<Zone> => {
    const res = await http.post<unknown>('/zones', payload)
    return normalizeZone(res.data)
  },
  update: async (zoneId: string, payload: unknown): Promise<Zone> => {
    const res = await http.patch<unknown>(`/zones/${encodeURIComponent(zoneId)}`, payload)
    return normalizeZone(res.data)
  },
  delete: async (zoneId: string): Promise<void> => {
    await http.delete(`/zones/${encodeURIComponent(zoneId)}`)
  },
}

